<section class="PricingSummary">
  <div class="PricingSummary__container">
    <p class="PricingSummary__text">
      Our rates are based on the experience and qualifications of our instructors. We recommend speaking to us before buying a full syllabus. 
    </p>
  </div>
</section>

<style lang="scss">
  @import './summary'
</style>